export default __webpack_public_path__ + "static/media/discord.2dec0c56.svg";